import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
// import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  position: relative;
  z-index: 1;
  .HeroImage_earlyAccessBanner {
    color: #FFFFFF;
    background-color: #DC1C4D;
    padding: 10px 25px;
    margin: 0;
    display: inline-block;
    margin: 0 0 30px 0;
    font-size: 20px;
    letter-spacing: 4px;
  }
  .HeroImage_logoTagline {
    color: #c6cc27;
    font-weight: 700;
    font-size: 24px;
    margin: 0 0 60px 0;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 36px;
    }
  }
  .HeroImage_headlineWrapper {
    width: 100%;
    position: relative;
    z-index: 1;
    padding: 60px 0 90px 0;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    @media (min-width: 992px) {
      padding: 120px 0 90px 0;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -10vw;
      right: 40vw;
      top: 0;
      bottom: 0;
      background-color: #000000;
      opacity: .5;
      z-index: 0;
      transform: skewX(-10deg);
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: #000000;
      opacity: .2;
      z-index: 0;
    }
    .container {
      position: relative;
      z-index: 1;
    }
  }
  .HeroImage_headline {
    text-align: left;
    color: #FFFFFF;
    margin: 0 0 30px 0;;
    font-size: 27px;
    text-transform: uppercase;
    font-weight: 700;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 48px;
      line-height: 58px;
    }
    @media (min-width: 1600px) {
      font-size: 50px;
    }
  }
  .HeroImage_subHeadline {
    text-align: left;
    color: ${colors.color2Dark};
    margin: 0;
    font-size: 24px;
    font-weight: 400;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 36px;
    }
  }
  .HeroImage_vipButtonWrapper {
    position: absolute;
    right: 0;
    bottom: -60px;
    width: 53px;
    height: 58px;
    display: none;
    @media (min-width: 992px) {
      width: 204px;
      height: 225px;
      display: block;
    }
    div {
      width: 100%;
      height: 100%;
    }
    span {
      display: block;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
  .HeroImage_vipButton {
    width: 100%;
    height: 100%;
    background-image: url('/images/hbt-logo-rev.svg');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }
`;

function HeroImage({ page }) {
  return (
    <div
      className={styles}
    >
      <div
        className="HeroImage_headlineWrapper"
        style={{ backgroundImage: `url('${get(page, 'page_image.contentUrl')}')` }}
      >
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-9 col-xl-7">
              <a href="/">
                <img
                  src="/images/hbt-logo-rev.svg"
                  alt="Homebuilder Tech"
                  className="w-75 w-lg-50 mb-4 mt-5 mt-lg-0 pt-5 pt-lg-0"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HeroImage.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'agenda',
})(HeroImage);



// WEBPACK FOOTER //
// ./src/components/InsideHeader.js